<header *ngIf="isShowingHeader$ | async">
    <div class="app-title">
        <div class="logo">
            <img src="/assets/images/logos/tcat.png">
        </div>
        <span>Simplifying Business Travel</span>
    </div>
</header>